export const list = [
    {
        label: '待我处理',
        value: 'pending'
    },
    {
        label: '与我相关',
        value: 'related'
    },
    {
        label: '我发起的',
        value: 'mine'
    },
]

export const pre_to = [
    ['payee_company_id', 'payee_company_id'],
    ['payee_company_name', 'payee_company'],
    ['id', 'payee_company_account_id'],
    ['bank', 'payee_bank'],
    ['bank_account', 'payee_account_name'],
    ['bank_number', 'payee_bank_number'],
]

export const initData = () => ({
    id: null,
    sub_account_info: null, //财务子账号信息
    fill_customer_id: null, // 填表人 ok
    customer_id: null, // 申请人 id ok
    principal_id: null, // 负责人 id ok 
    principal_name: null, // 负责人名称 ok 
    company_id: null, // 开店主体 id ok
    team_id: null, // 申请团队 ok
    shop_platform: null, // 开店平台 ok
    invoice_company_id: null, // 开票主体 id
    shop_type: null, // 店铺类型 ok
    shop_name: null, // 店铺名称 ok
    deposit: null, // 押金 ok
    certification_cost: null, // 认证款 ok
    refund_at: null, // 预计退回时间 ok
    sale_type: null, // 售卖类型 ok
    receipt_platform: null, // 收款平台 ok
    sharing_percent: null, // 分成比例 ok
    fee_percent: null, // 手续费比例 ok
    payment_means: null, // 结算方式 ok
    payee_bank: null, // ok
    payee_account_name: null, // ok
    payee_bank_number: null, // ok
    payee_company: null,
    payee_company_id: null, // ok
    payee_company_account_id: null, // ok
    payee_user: null, // 收款对接人 ok
    payee_user_id: null, // 收款对接人 id ok
    real_product: null, // 是否为实体商品 ok
    deliver_type: null, // 发货方式 ok
    desc: null, // 备注 ok
    sale_status: null, // 售卖状态
    company_consistency: [], // 主体信息
    contracts: [],
    materials: []
})


export const initThridData = () => ({
    id: null,
    sub_account_info: null, //财务子账号信息
    deposit: null, // 押金 
    certification_cost: null, // 认证款 
    sharing_percent: null, // 分成比例 
    fee_percent: null, // 手续费比例 
    payment_means: null, // 结算方式 
    invoice_company_id: null, // 开票主体 
    invoice_company_name: null, // 开票主体name
    sale_type: null, // 售卖类型 
    payee_bank_number: null, // 收款账户号
    payee_company_account_id: null, // 收款账户 id
    payee_user_id: null, // 收款对接人ID
    payee_user: null, // 收款对接人name
    frequency: null, // 对账频率
    mall_code: null, // 商城编码
    sale_type_other: null, // 售卖商品描述
    principal_id: null, // 店铺负责人
    manager_id: null, //店铺管理人
    principal_name: null,
    manager_name: null,
})

export const tableFields = [
    {
        text: 'uid',
        align: 'center',
        value: 'uid',
        width: 150
    },
    {
        text: '店铺名称',
        align: 'center',
        value: 'shop_name',
        width: 150
    },
    {
        text: '店铺负责人',
        align: 'center',
        value: 'principal_name',
        width: 150
    },
    {
        text: '团队',
        align: 'center',
        value: 'team_id',
        type: 'team_field',
        width: 150
    },
    {
        text: '开店平台',
        align: 'center',
        value: 'shop_platform',
        width: 150
    },
    {
        text: '申请人',
        align: 'center',
        value: 'apply_customer_name',
        width: 150
    },
    {
        text: '填表人',
        align: 'center',
        value: 'fill_customer_name',
        width: 150
    },
    {
        text: '状态',
        align: 'center',
        value: 'status',
        width: 200
    }
]

export const thrid_fields = [
    {
        text: '店铺编号',
        align: 'center',
        value: 'uid',
        width: 150,
        
    },
    {
        text: '商城编号',
        align: 'center',
        value: 'mall_code',
        width: 150
    },
    {
        text: '开店流程编号',
        align: 'center',
        value: 'opening_shop_order_uid',
        width: 150
    },
    {
        text: '申请开店公司主体',
        align: 'center',
        value: 'company_name',
        width: 150
    },
    {
        text: '收入确认公司主体',
        align: 'center',
        value: 'payee_company',
        width: 150
    },
    {
        text: '开店平台',
        align: 'center',
        value: 'shop_platform',
        width: 150
    },
    {
        text: '店铺类型',
        align: 'center',
        value: 'shop_type',
        width: 150
    },
    {
        text: '店铺名称',
        align: 'center',
        value: 'shop_name',
        width: 150
    },
    {
        text: '店铺负责人',
        align: 'center',
        value: 'principal_name',
        width: 150
    },
    {
        text: '店铺实际管理人',
        align: 'center',
        value: 'manager_name',
        width: 150
    },
    {
        text: '开店团队',
        align: 'center',
        value: 'team_id',
        type: 'team_field',
        width: 150
    },
    {
        text: '收款团队',
        align: 'center',
        value: 'team_id',
        type: 'team_field',
        width: 150
    },
]

export const status_thrid = [
    {
        title: '正常运营',
        key: 'normal',
        color: '#19be6b',
    },
    {
        title: '暂停运营',
        key: 'suspended',
        color: '#ff9900',
    },
    {
        title: '已关停',
        key: 'closed',
        color: '#ed4014',
    },
    {
        title: '已移除',
        key: 'dumped',
        color: '#ed4014',
    },
]

export const company_consistency_list = [
    {
        label: '主体一致',
        value: 'consistent',
        color: '#00E676'
    },
    {
        label: '主体不一致',
        value: 'inconsistent',
        color: '#F57F17'
    },
    {
        label: '风险店铺',
        value: 'risk',
        color: '#E53935'
    },
]

export const company_consistency_list_hash = company_consistency_list.reduce((t, i) => {
    t[i.label] = i
    return t
}, {})

export const sale_status = [
    {
        label: '确定现阶段会售卖产品',
        value: 'current'
    },
    {
        label: '确定未来会售卖产品',
        value: 'future'
    },
]


export const sale_status_hash = sale_status.reduce((t,i)=>{
    t[i.value] = i
    return t
},{})